import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Video from './components/Video';
import WhyProject from './components/WhyProject';
import FourPillars from './components/FourPillars';
import TwoPaths from './components/TwoPaths';
import WhyHealth from './components/WhyHealth';
import WhoThisIsFor from './components/WhoThisIsFor';
import NigeriaSection from './components/NigeriaSection';
import ApplicationForm from './components/ApplicationForm';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowFloatingBtn(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const element = document.getElementById('application-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <SeoJsonLd />
      <Navbar scrolled={scrolled} />
      <Hero />
      <Video />
      <WhyProject />
      <FourPillars />
      <TwoPaths />
      <WhyHealth />
      <WhoThisIsFor />
      <NigeriaSection />
      <ApplicationForm />
      <Footer />

      {/* Floating Apply Now button — mobile only */}
      <div
        className={`md:hidden fixed bottom-6 right-4 z-50 transition-all duration-300 ${
          showFloatingBtn
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <button
          onClick={scrollToForm}
          className="flex items-center gap-2 bg-amber-500 text-white px-7 py-3.5 rounded-full text-sm font-bold shadow-2xl hover:bg-amber-600 active:scale-95 transition-all duration-200 whitespace-nowrap cursor-pointer"
          style={{ boxShadow: '0 8px 32px rgba(245,158,11,0.45)' }}
        >
          <i className="ri-edit-line text-base"></i>
          Apply Now
        </button>
      </div>
    </div>
  );
}
